import React from 'react';
import { hasContent } from './utils';

const EmergencySection = ({ chemicalDetails }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 transition-all duration-300 hover:shadow-xl">
      <h2 className="text-2xl font-bold mb-6">
        <i className="fas fa-exclamation-triangle mr-2"></i>Emergency Guidelines
      </h2>
      <div className="space-y-6">
        {/* Use new backend structure: chemicalDetails.emergency_guidelines.spill_measures */}
        {hasContent(chemicalDetails.emergency_guidelines?.spill_measures) && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <h3 className="text-lg font-bold text-yellow-800 mb-4">
              <i className="fas fa-tint mr-2"></i>Spill Measures
            </h3>
            <div className="space-y-3">
              {Array.isArray(chemicalDetails.emergency_guidelines.spill_measures) ? (
                chemicalDetails.emergency_guidelines.spill_measures.map((measure, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <i className="fas fa-exclamation-circle text-yellow-600 mt-1"></i>
                    <span className="text-yellow-800">{measure}</span>
                  </div>
                ))
              ) : (
                <div className="flex items-start space-x-3">
                  <i className="fas fa-exclamation-circle text-yellow-600 mt-1"></i>
                  <span className="text-yellow-800">{chemicalDetails.emergency_guidelines.spill_measures}</span>
                </div>
              )}
            </div>
          </div>
        )}
        {/* Emergency Contact Information */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-lg font-bold text-blue-800 mb-4">
            <i className="fas fa-phone mr-2"></i>Emergency Response
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 bg-blue-100 rounded">
              <div className="font-semibold text-blue-800">Emergency Services</div>
              <div className="text-blue-700">Call local emergency services immediately</div>
            </div>
            <div className="p-4 bg-blue-100 rounded">
              <div className="font-semibold text-blue-800">Poison Control</div>
              <div className="text-blue-700">Contact poison control center if needed</div>
            </div>
          </div>
        </div>
        {/* No emergency info */}
        {!hasContent(chemicalDetails.emergency_guidelines?.spill_measures) && (
          <div className="p-12 bg-gray-100 rounded-lg hover:bg-slate-300 transition-all">
            <div className="text-center">No emergency guidelines information available.</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmergencySection;
